module.exports = __webpack_public_path__ + "img/Hawaiian Meal-Pork.10368044.jpg";